import { Amel, Asiv, Dewa, Fauzi, Madina, Panggih, Sheva, Tafi, Jule } from "../assets";

const demangData = [
    {
        id: 1,
        name: "Ahmad Fauzi Dwiki Saputra",
        period: "2016 - 2017",
        image: Fauzi,
        isCurrent: false,
    },
    {
        id: 2,
        name: "Radiatri Mahardika Dewangga",
        period: "2017 - 2019",
        image: Dewa,
        isCurrent: false,
    },
    {
        id: 3,
        name: "Panggih Rizqi Nugroho",
        period: "2019 - 2020",
        image: Panggih,
        isCurrent: false,
    },
    {
        id: 4,
        name: "Siti Muntafi'ah",
        period: "2020 - 2021",
        image: Tafi,
        isCurrent: false,
    },
    {
        id: 5,
        name: "Sheva Natha Ardhieka Callista",
        period: "2021 - 2022",
        image: Sheva,
        isCurrent: false,
    },
    {
        id: 6,
        name: "Naora Ismi Asiva",
        period: "2022 - 2023",
        image: Asiv,
        isCurrent: false,
    },
    {
        id: 7,
        name: "Madina Lutfah",
        period: "2023 - 2024",
        image: Madina,
        isCurrent: false,
    },
    {
        id: 8,
        name: "Regina Salsa Amelia",
        period: "2024 - 2025",
        image: Amel,
        isCurrent: false,
    },
    {
        id: 9,
        name: "Zuleika Balqis Khoirunnida",
        period: "2025 - Sekarang",
        image: Jule,
        isCurrent: true,
    },
];

export default demangData;
